import {inject} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {map} from "rxjs/operators";

export function fetchFile(fileName: string, path: string = "/api/storage/view/"): Promise<File> {
    return new Promise(async (resolve: any) => inject(HttpClient)
        .get(`${path}${fileName}`, { responseType: 'blob' })
        .pipe(map((file: any) => new File([file], fileName)))
        .subscribe(resolve));
}